/* AquaRuby Workspace (Android staff app) - start-up used by src/index.js.
   Website: render() is called at once, exactly as before.
   Android app: waits until the native bridge is ready (server address from the app id), then renders; if the app
   cannot work (e.g. a Preview app built without its server address) a short message is shown instead. */
import { nativeApp } from './env';

export { isNativeApp } from './env';

const START_FAILED = 'The app could not start. Close it and open it again.';

export function startApp(render, renderProblem) {
  const n = nativeApp();
  if (!n) { render(); return; }
  Promise.resolve(n.ready)
    .then((r) => { if (r && r.ok) render(); else renderProblem((r && r.message) || START_FAILED); })
    .catch(() => renderProblem(START_FAILED));
}

/** Plain message screen (no styles needed). */
export function ProblemScreen({ message }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: 'system-ui, sans-serif', color: '#0f172a', background: '#fff' }}>
      <div style={{ maxWidth: 360, textAlign: 'center' }}>
        <img src="/brand/aquaruby-logo.png" alt="AquaRuby" style={{ height: 48, margin: '0 auto 16px', display: 'block' }} />
        <div style={{ fontWeight: 600, fontSize: 18 }}>AquaRuby Workspace</div>
        <p style={{ marginTop: 8, fontSize: 14, color: '#475569' }}>{message}</p>
      </div>
    </div>
  );
}
